import { useEffect } from "react";
import {
  useResetSplitPaymentAtoms,
  useDeleteSplitPaymentState,
} from "../atoms/useSplitPaymentV2Atom";
import { useSetPriorityModal } from "../atoms/usePriorityModal";
import useResetLedger from "../atoms/useResetLedger";
import usePosOrderHook from "./usePosOrderHook";
import { useHasSession } from "./usePosOrderTableSessionHook";
import useIsOrderEditingHook from "./useIsOrderEditingHook";
import { OrderV2 } from "../v2/queries/interfacesV2";
import usePaymentLedgerHook from "./usePaymentLedgerHook";

const useResetPaymentLedgerHook = () => {
  const hasSession = useHasSession();
  const [value, setter] = useResetLedger();
  const { resetPosOrderStates } = usePosOrderHook();
  const { editOrder } = useIsOrderEditingHook();
  const setPriorityModal = useSetPriorityModal();
  const resetSplitPaymentAtoms = useResetSplitPaymentAtoms();
  const { orderId } = usePaymentLedgerHook(false);
  const deleteSplitPaymentState = useDeleteSplitPaymentState();

  const finishSplitPayment = () => {
    resetPosOrderStates(
      hasSession ? undefined : (editOrder as OrderV2),
      hasSession
    );
    setPriorityModal("", {});
    resetSplitPaymentAtoms();
    deleteSplitPaymentState(orderId);
  };

  useEffect(() => {
    if (value) {
      finishSplitPayment();
      setter(false);
    }
  }, [value]);

  return { finishSplitPayment };
};

export default useResetPaymentLedgerHook;
